<template>
  <div>
    <div
      class="fixed w-full h-full inset-0 z-10"
      style="background: rgba(0,0,0,.5)"/>
    <div
      class="fixed w-full h-screen overflow-auto inset-0 z-30"
      @click="$emit('close')">
      <div
        :class="`p-${padding} max-w-${width}`"
        class="my-8 bg-white m-auto rounded overflow-hidden shadow-lg"
        @click.stop>
        <slot/>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      padding: {
        type: [String, Number],
        default: 4
      },
      width: {
        type: String,
        default: '4xl'
      }
    }
  }
</script>
